/**
 * 敏感行为管理
 */
import {behaviors, updateBehaviorStatus} from 'message-control/services/sensitive-behavior'
import createModel from 'utils/model'

export default createModel({
    namespace: 'messageControl_sensitiveBehaviorManage',

    state: {
        tableData: {},
    },

    effects: {
        *behaviors(_, {call, put}) {
            const res = yield call(behaviors)
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                },
            })
            return res
        },
        *updateBehaviorStatus({payload}, {call}) {
            return yield call(updateBehaviorStatus, payload)
        },
    },

    reducers: {},
})
